<template>
  <div class="create-note">
    <div class="row">
      <div class="col-sm-12">
        <div>
          <mu-text-field v-model="note.name" label="Namn" labelFloat/>
        </div>
        <div>
          <mu-text-field v-model="note.text" label="Text" labelFloat :fullWidth="true"/>
        </div>
      </div>
      <div class="col-sm-12">
        <mu-raised-button v-if="!isUpdate" class="demo-raised-button" label="Lägg till" icon="add" primary @click="createNote"/>
        <mu-raised-button v-if="isUpdate" class="demo-raised-button" label="Uppdatera" icon="add" primary @click="createNote"/>
        <mu-raised-button class="demo-raised-button" label="Ta bort" icon="delete" @click="deleteNote"/>
        <mu-raised-button class="demo-raised-button" label="Avbryt" icon="cancel" @click="closeDialog"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createNote, updateNote, deleteNote } from '../store/actions'

export default {
  name: 'CreateNote',
  props: {
    editNote: {
      type: Object
    }
  },
  data () {
    return {
      note: {
        name: '',
        text: ''
      }
    }
  },
  mounted () {
    if (this.editNote) {
      this.note = JSON.parse(JSON.stringify(this.editNote))
    }
  },
  computed: {
    isUpdate () {
      return this.note.id
    }
  },
  methods: {
    createNote () {
      if (!this.note.id) {
        createNote(this.$store, this.note).then(() => {
          this.closeDialog()
        })
      } else {
        updateNote(this.$store, this.note).then(() => {
          this.closeDialog()
        })
      }
    },
    deleteNote () {
      deleteNote(this.$store, this.note).then(() => {
        this.closeDialog()
      })
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-note {
   
}
</style>
